import React, {useEffect, useRef, useState, Fragment} from "react";
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
// layout for this page
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import {Link, useHistory} from "react-router-dom";
import shopService from "./shop.service";

function ShopReviewDetail({ match, history }) {
  const router = useHistory();
  const { id } = match.params;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const remove = () => {

  }

  const fetchData = async () => {
    setLoading(true);
    if (id) {
      const res = await shopService.reviewDetail(id);
      console.log(res);
      if (res.code === 200) {
        setData(res.data);
      }
    }
    setLoading(false);
  };

  useEffect( () => {
    fetchData();
  }, []);

  if (loading) return <div>로딩중..</div>;
  return (
    <>
      <SimpleHeader name="Form elements" parentName="Forms" />
      <Container className="mt--6" fluid>
        <Card className="mb-4">
          <CardHeader>
            <Row>
              <Col xs="12">
                <h3 className="mb-0">업체 리뷰 관리 상세 </h3>
              </Col>
              <Col className="text-right" xs="12">
                <Button
                  className="btn-round btn-icon"
                  color="danger"
                  onClick={remove}
                  size="sm"
                >
                  <span className="btn-inner--text">삭제하기</span>
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Row>
              <Col md="8">
                <Row>
                  <Col md="2">
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="example3cols1Input"
                      >
                        리뷰 등록 날짜
                      </label>
                      <div className="form-group">
                        {data?.createdAt}
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="example3cols1Input"
                      >
                        아이디
                      </label>
                      <div className="form-group">
                        {data?.user.loginId}
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="example3cols1Input"
                      >
                        카테고리
                      </label>
                      <div className="form-group">
                        {data?.shopCategory}
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="example3cols1Input"
                      >
                        업체명
                      </label>
                      <div className="form-group">
                        {data?.shopName}
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="example3cols1Input"
                      >
                        회원명
                      </label>
                      <div className="form-group">
                        {data?.user.name}
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Row>
                  <Col>
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="example3cols1Input"
                      >
                        리뷰 내용
                      </label>
                      <div className="form-group">
                        {data?.content}
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Row>
                  <Col>
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="example3cols1Input"
                      >
                        사진
                      </label>
                      <div className="form-group">
                        {data?.images.map(i => {
                          return (
                            <a
                              className="avatar avatar-xl rounded ml-1 h-100"
                              href={i.name}
                              target="_blank"
                            >
                              <img src={i.name}/>
                            </a>
                          )
                        })}
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Row>
                  <Col>
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="example3cols1Input"
                      >
                        사장님 답변
                      </label>
                      <div className="form-group">
                        {data?.comment}
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>


          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default ShopReviewDetail;
